import { ticketPriorities, ticketStatuses } from '../constants';
import { TicketPriority, TicketStatus } from '../model';

export const formatTicket = {
    status: (status?: TicketStatus) => {
        if (!status) {
            return '';
        }

        if (status === TicketStatus.STATUS_UNSPECIFIED) {
            return 'Не указан';
        }

        const { label } =
            ticketStatuses.find((s) => {
                return s.value === status;
            }) ?? {};

        return label;
    },
    priority: (priority?: TicketPriority) => {
        if (!priority) {
            return '';
        }

        if (priority === TicketPriority.PRIORITY_UNSPECIFIED) {
            return 'Не указан';
        }

        const { label } =
            ticketPriorities.find((s) => {
                return s.value === priority;
            }) ?? {};

        return label;
    },
    date: (dateString?: string) => {
        if (!dateString) {
            return '';
        }

        return new Date(dateString).toLocaleString();
    },
};
